import React from "react";
import "./Card.css";
import "../../image/Captura morty.png";

const Card = () => {
  const [proyect, setProyect] = React.useState({
    name: "",
    linkWeb: "",
    linkPhotoWeb: "",
    comments: "",
  });

  const [listProject, setListProject] = React.useState([]);
  const [formComplet,setFormComplet]=React.useState(false);
  const [ocultar,setOcultar]=React.useState(
    
    
    true);

//

  const HandChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;
    setProyect({
      ...proyect,
      [name]: value,
    });
  };

  const ResetForm = () =>{

    setProyect({
      name: "",
      linkWeb: "",
      linkPhotoWeb: "",
      comments: "",
    });

  }


  const EnterListProyect = () => {

    if(
      !proyect.name.trim() ||
      !proyect.linkWeb.trim() ||
      !proyect.linkPhotoWeb.trim() ||
      !proyect.comments.trim() 
     
    ){
   
      setFormComplet(true)
      return
     
    }
    setFormComplet(false)
    setListProject([
      ...listProject,
      {
        name: proyect.name,
        linkWeb: proyect.linkWeb,
        linkPhotoWeb: proyect.linkPhotoWeb,
        comments: proyect.comments,
      },
    ]);

    setProyect({
      name: "",
      linkWeb: "",
      linkPhotoWeb: "",
      comments: "",
    });
  };

  return (
    <div>
      {ocultar &&
      <form className=" form-style  container container-fluid ">
        <h3 className=""> Form Create </h3>

        <div className="m-3">
          <label for=""> Name proyect: </label>
          <input
            type="text"
            placeholder="Name Proyect   "
            onChange={HandChange}
            className="form-control"
            name="name"
            value={proyect.name}
          />
        </div>

        <div className="m-3">
          <label for=""> Link site web : </label>
          <input
            type="text"
            placeholder="The link site web  "
            onChange={HandChange}
            className="form-control"
            name="linkWeb"
            value={proyect.linkWeb}
          />
        </div>

        <div className="m-3">
          <label for=""> Link photo site web : </label>
          <input
            type="text"
            placeholder="The Link Site Web "
            onChange={HandChange}
            className="form-control"
            name="linkPhotoWeb"
            value={proyect.linkPhotoWeb}
          />
        </div>

        <div className="m-3">
          <label for=""> Commments about proyect : </label>
        </div>
        <div className=" ">
          <div className="form-floating m-3 ">
            <textarea
              placeholder="Ingresa el Titulo"
              onChange={HandChange}
              className="form-control "
              name="comments"
              value={proyect.comments}
            />
            <label for="floatingTextarea">Comments</label>
          </div>
        </div>
    <div className="m-3">
      
    { formComplet &&

      <label  className="changeColor"for=""> Incomplete form, please valid </label>

    }
    </div>


        <button
          type="button"
          onClick={() => EnterListProyect()}
          className="btn btn-primary m-3"
        >
          Add
        </button>
        <button  onClick={()=>ResetForm() } type="button" className="btn btn-danger">
          Cancel
        </button>


        
      </form>
}
    </div>
  );
};

export default Card;
